import { css } from "@emotion/react";
import { MEDIA_QUERY_FOR_PC } from "constants/mediaQueryForPc";
import { MEDIA_QUERY_FOR_SP } from "constants/mediaQueryForSp";

const threeLineClamp = css`
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
`;

export const titleStyle = css`
  ${threeLineClamp};
  color: #1e1e1e;
  font-weight: 700;
  letter-spacing: 0;

  ${MEDIA_QUERY_FOR_PC} {
    font-size: 16px;
    line-height: 24px;
  }

  ${MEDIA_QUERY_FOR_SP} {
    font-size: 12px;
    line-height: 16px;
  }
`;

export const shopNameStyle = css`
  ${threeLineClamp};
  color: #5c5c5c;
  letter-spacing: 0;
  line-height: 24px;

  ${MEDIA_QUERY_FOR_PC} {
    font-size: 16px;
  }

  ${MEDIA_QUERY_FOR_SP} {
    font-size: 12px;
  }
`;

export const footerStyle = css`
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  row-gap: 8px;

  ${MEDIA_QUERY_FOR_PC} {
    column-gap: 10px;
  }

  ${MEDIA_QUERY_FOR_SP} {
    column-gap: 8px;
  }
`;

export const amountStyle = css`
  letter-spacing: 0;
  overflow-wrap: anywhere;
  word-break: keep-all;

  ${MEDIA_QUERY_FOR_PC} {
    font-size: 14px;
    line-height: 20px;
  }

  ${MEDIA_QUERY_FOR_SP} {
    font-size: 12px;
    line-height: 16px;
  }
`;

export const taxStyle = css`
  display: inline-block;
  margin-left: 4px;
  word-break: keep-all;
`;

export const labelWrapperStyle = css`
  flex-shrink: 0;
`;
